export const phoneNum = {
  label: "+1-844-792-3620",
  value: "+18447923620",
};